export const PROVIDER_FIELD_GROUP = 'RD2.ProviderFieldConfiguration';
export const PROVIDER_FIELD_FAX = `${PROVIDER_FIELD_GROUP}.Fax`;
export const PROVIDER_FIELD_PHONE = `${PROVIDER_FIELD_GROUP}.Phone`;
